import React from 'react'
import myImage from "../assets/heroImage.JPG";
import {TbArrowRightCircle} from 'react-icons/tb';
import {Link} from "react-scroll";

const Home = () => {
  return (
    <div name="Home" className="h-screen w-full bg-gradient-to-b from-black via-black to-gray-800">
        <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row">
            <div className="flex flex-col justify-center h-full">
                <h2 className="text-4xl sm:text-7xl font-bold text-white ">I'm an aspiring Web/Software Developer</h2>
                <p className="text-gray-500 py-4 max-2-md">
                    I am a recent graduate with a degree in Computer Science.
                    Currently, I am working on improving my web development skills using technologies such as:
                    React, Tailwind, GraphQL, Stripe and FireBase
                </p>
                <div>
                    <Link to="Projects" smooth duration={700} className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-700 via-green to-green-700 cursor-pointer">
                        Portfolio
                        <span className="group-hover:rotate-90 duration-300">
                            <TbArrowRightCircle size={20} className="ml-2"/>
                        </span>
                    </Link>
                </div>
            </div>
            <div>
                <img src={myImage} alt="Imagine a nice Pic"
                className="rounded-3xl mx-auto w-2/3 md:w-full p-3"/>
            </div>
        </div>
    </div>
  )
}

export default Home